import React from 'react';
import { motion } from 'framer-motion';
import { Users, FileCheck, Award } from 'lucide-react';

const stats = [
  {
    icon: <Users className="w-6 h-6" />,
    value: "10+",
    label: "Happy Users"
  },
  {
    icon: <FileCheck className="w-6 h-6" />,
    value: "10+",
    label: "Resumes Created"
  },
  {
    icon: <Award className="w-6 h-6" />,
    value: "95%",
    label: "Success Rate"
  }
];

export default function Stats() {
  return (
    <section className="py-12 bg-gradient-to-r from-indigo-600 to-purple-600">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="text-center text-white"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="flex justify-center mb-4">
                {stat.icon}
              </div>
              <div className="text-4xl font-bold mb-2">{stat.value}</div>
              <div className="text-indigo-100">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}